import posthog from "posthog-js";

// ✅ Réplique de platform_used
export const trackPlatformUsed = (category, action, failed = false) => {
  posthog.capture(failed ? "platform_failed" : "platform_used", {
    category,
    action,
  });
};
